export default __webpack_public_path__ + "static/media/rocket_3.52e4bcef.svg";